import { render } from "./IconBox.vue?vue&type=template&id=66873457"
import script from "./IconBox.vue?vue&type=script&lang=js"
export * from "./IconBox.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__